import React from "react";
import moment from "moment/moment";


export function getProductDetailsViewed(product) {
    return {
        'event': 'detailView',
        'ecommerce': {
            'detail': {
                'products': [{
                    'name': product.name,
                    'Id': product.id,
                    'price': product.price,
                    'brand': "",
                    'category': product.category
                }]
            }
        }
    }
}

export function getProductImpressions(products) {
    const str = products.map((p, idx) => ({
        'name': p.name,
        'Id': p.productId,
        'price': p.price, // Total price for the period
        'brand': p.name,
        'category': "", // Either Hiking, Camping or Travel.
        'list': [], // Integer
        'position': idx // Integer
    }));

    return {
        'event': 'productImpressions',
        'ecommerce': {
            'currencyCode': 'ZAR',
            'impressions': JSON.stringify(str)
        }
    }
}

export function addGtmEvent(event) {
    (window as any).dataLayer?.push(event)
}

export function getAddToCart({name, id, price, category, qty, tripDays,}) {

    return {
        'event': 'addToCart',
        'ecommerce': {
            'currencyCode': 'ZAR',
            'add': {
                'products': [{
                    'name': name,
                    'Id': id,
                    'price': price,
                    'brand': "",
                    'category': category,
                    'quantity': qty,
                    'metric1': tripDays
                }]
            }
        }
    }
}


export function getOrderReceived(order) {

    return {
        'event': 'purchase',
        'ecommerce': {
            'purchase': {
                'actionField': {
                    'id': order.id,
                    'revenue': order.total,
                    'Tax': 0,
                },
                'products': order.products.items.map(p => ({
                    'name': p.productInfo.name,
                    'Id': p.productId,
                    'price': p.productInfo.price, // Total price for the period
                    'brand': p.productInfo.name,
                    'category': "", // Either Hiking, Camping or Travel.
                    'quantity': p.qty, // Integer
                    'metric1': moment(order.startTime).diff(order.endTime, "days") // Integer
                }))
            }
        }
    }
}
